import { render, staticRenderFns } from "./AccommodationEdit.vue?vue&type=template&id=26220645&"
import script from "./AccommodationEdit.vue?vue&type=script&lang=ts&"
export * from "./AccommodationEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AccommodationEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports